import { useDispatch, useSelector } from 'react-redux';
import { useEffect, useState } from 'react';
import operation from '@redux/admin/admin-operation';
import adminSelectors from '@redux/admin/admin-selectors';
import { lessonConf } from '@root/conf/tableConf';
import { DenseTable, FormLesson } from '@root/components';
import styled from 'styled-components';
import AddCircleOutlineOutlinedIcon from '@mui/icons-material/AddCircleOutlineOutlined';
import IconButton from '@mui/material/IconButton';

export const LessonsTabs = () => {
  const [isModal, setIsModal] = useState(false);
  const [chooseId, setChooseId] = useState(null);
  const lessons = useSelector(adminSelectors.getLessons);
  const dispatch = useDispatch();

  useEffect(() => {
    dispatch(operation.getAllLessons());
  }, [dispatch]);

  const openModal = () => {
    setIsModal(true);
  };

  const closeModal = () => {
    setIsModal(false);
    setChooseId(null);
  };

  const onClickHandel = id => {
    setChooseId([...lessons].find(el => el._id === id));
    openModal();
  };

  const menuConf = [
    {
      label: () => 'Edit',
      key: 'base',
      type: 'modal',
      onClickHandel: onClickHandel
    },

  ];
  return (
    <>
      <TableWrapper>
        <DenseTable
          conf={lessonConf}
          data={lessons}
          onClickHandel={onClickHandel}
          menuConf={menuConf}
        />
      </TableWrapper>
      <IconWrapper>
        <IconButton aria-label="add" onClick={openModal}>
          <AddCircleOutlineOutlinedIcon color="primary" fontSize="large" />
        </IconButton>
      </IconWrapper>

      {isModal && <FormLesson handleClose={closeModal} data={chooseId} />}
    </>
  );
};

const TableWrapper = styled.div`
  margin: 50px 0;
`;

const IconWrapper = styled.div`
  position: fixed;
  bottom: 40px;
  right: 20px;
`;
